import { gql } from "lib/apolloClient";
import {
  assessmentToolFragment,
  organizationFragment,
} from "./AssessmentToolFragment";
import { standardRubricFragment } from "AppComponents/StandardRubric/modules/StandardRubricFragments";
import { rubricFragment } from "Rubric/modules/RubricFragments";

export const getOrganizationDpAssessmentRubricQuery = gql`
  query getOrganizationDpAssessmentRubric(
    $id: ID!
    $filters: DPAssessmentRubricFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        dpAssessmentRubrics(filters: $filters) {
          ...dpAssessmentRubricItem
        }
      }
    }
  }
  ${assessmentToolFragment.dpAssessmentRubric}
`;

export const getDpAssessmentRubricQuery = gql`
  query getDpAssessmentRubric($id: ID!) {
    node(id: $id, type: MYP_OBJECTIVE_RUBRIC) {
      ... on MypObjectiveRubric {
        ...mypObjectiveRubricItem
      }
    }
  }
  ${assessmentToolFragment.mypObjectiveRubricWithPresetData}
`;

export const getOrganizationScoreRubricsQuery = gql`
  query getOrganizationScoreRubrics(
    $id: ID!
    $filters: AssessmentToolFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationItem
      }
    }
  }
  ${organizationFragment.scoreRubricList}
`;

export const getOrganizationStandardRubricsQuery = gql`
  query getOrganizationStandardRubrics(
    $id: ID!
    $filters: AssessmentToolFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationItem
      }
    }
  }
  ${organizationFragment.standardRubricList}
`;

export const getOrganizationRubricsAndScoreBasedRubricsQuery = gql`
  query getOrganizationRubricAndScoreBasedRubric(
    $id: ID!
    $filters: AssessmentToolFilters
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        assessmentTools(
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          edges {
            node {
              id
              assessmentToolType
              assessmentToolItem {
                id
                ... on Rubric {
                  ...rubricItem
                }
                ... on StandardRubric {
                  ...standardRubricItem
                }
              }
            }
          }
        }
      }
    }
  }

  ${standardRubricFragment.standardRubric}
  ${rubricFragment.rubric}
`;
